<template lang="pug">
.links
  .sep-link(v-for="(link, i) in links")
    RogueLink(:to="link.url" :style="{ color }") {{ __(link.text, 'auto') }}
    span.sep(v-if="i !== links.length - 1" :style="{ color }") |
</template>
<script setup lang="ts">
withDefaults(defineProps<{
  links?: { url: string, text: string }[],
  color?: string,
}>(), {
  links : () => ([]),
  color : '#333',
})
</script>
<style lang="scss" scoped>
.sep-link {
  display: inline-flex;
  background-color: inherit;

  a {
    font-family: $font-condensed;
    background-color: transparent;
  }

  .sep {
    margin: 1px $space-xxxs 0;
  }
}
</style>
